export default __webpack_public_path__ + "static/media/mobile-faq.4a23dac1.svg";